import type { Editor } from '@tiptap/react';
import { buildNoteDoc, serializeNote, suggestionIdsIn } from 'utils/noteDocument';

export function docToHtml(editor: Editor): string {
  return serializeNote(editor.state.doc);
}

export function docToSuggestionIds(editor: Editor): string[] {
  return suggestionIdsIn(editor.state.doc);
}

export function rebuildNote(editor: Editor, html: string): void {
  const { tr } = editor.state;
  tr.replaceWith(0, tr.doc.content.size, editor.schema.nodeFromJSON(buildNoteDoc(html)).content);
  editor.view.dispatch(tr.setMeta('addToHistory', false).setMeta('preventUpdate', true));
}
